import ChatPhoto from './Partials/ChatPhoto.vue';
import ChatVideo from './Partials/ChatVideo.vue';
import ChatAudio from './Partials/ChatAudio.vue';
import ChatDocument from './Partials/ChatDocument.vue';
import ChatReplyTo from './Partials/ChatReplyTo.vue';
import ChatReaction from './Partials/ChatReaction.vue';
import ChatPreviewOverlay from './Partials/ChatPreviewOverlay.vue';
import ReactionModal from './Modals/ReactionModal.vue';
import MessageInfoModal from './Modals/MessageInfoModal.vue';
import DiscardConfirmationModal from './Modals/DiscardConfirmationModal.vue';
import FilePreviewModal from "@/Shared/Components/FilePreviewModal";
import ChatAdvisorPopup from "./Partials/ChatAdvisorPopup";
import ApartmentLayout from "@/Layouts/ApartmentLayout";
import ClientApartmentLayout from "@/Layouts/ClientApartmentLayout";
import {
    DotsVerticalIcon,
    PaperAirplaneIcon,
    PlusIcon,
    DocumentTextIcon,
    DownloadIcon,
    ArrowsExpandIcon,
    XIcon,
    FolderOpenIcon,
    CheckCircleIcon,
    PhotographIcon,
    VideoCameraIcon,
    CameraIcon,
    MicrophoneIcon,
    UserIcon,
    EmojiHappyIcon,
    ChevronDownIcon,
    TrashIcon,
    PlayIcon,
    PauseIcon,
    DuplicateIcon,
    SearchIcon,
    BellIcon,
    MailOpenIcon,
    CalendarIcon,
    ReplyIcon,
    LinkIcon,
    CheckIcon,
    RefreshIcon,
    CodeIcon
} from "@heroicons/vue/outline";

import MessageMenu from "@/Shared/Components/MessageMenu.vue";
import EmojiPicker from 'vue3-emoji-picker';
import 'vue3-emoji-picker/css';
import { io } from "socket.io-client";
import { Link } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";

import { encodeBuyerId, decodeBuyerId } from "@/Shared/Utils/buyerIdObfuscation";
import moment from 'moment';


export default {
    props: ["apartment", "buyers", "project", "is_advisor", "topics", "topic"],
    components: {
        ApartmentLayout,
        ClientApartmentLayout,
        Link,
        DotsVerticalIcon,
        PaperAirplaneIcon,
        PlusIcon,
        DocumentTextIcon,
        DownloadIcon,
        ArrowsExpandIcon,
        XIcon,
        FolderOpenIcon,
        CheckCircleIcon,
        PhotographIcon,
        VideoCameraIcon,
        CameraIcon,
        MicrophoneIcon,
        UserIcon,
        EmojiHappyIcon,
        ChevronDownIcon,
        EmojiPicker,
        TrashIcon,
        PlayIcon,
        PauseIcon,
        DuplicateIcon,
        SearchIcon,
        BellIcon,
        MailOpenIcon,
        CalendarIcon,
        ReplyIcon,
        MessageMenu,
        ChatPhoto,
        ChatVideo,
        ChatAudio,
        ChatDocument,
        ChatReplyTo,
        ChatReaction,
        ChatPreviewOverlay,
        ReactionModal,
        MessageInfoModal,
        DiscardConfirmationModal,
        FilePreviewModal,
        ChatAdvisorPopup,
        LinkIcon,
        CheckIcon,
        RefreshIcon,
        CodeIcon
    },
    data() {
        return {
            activeSidebar: null,
            showBuyerDropdown: false,
            showEmojiPicker: false,
            showFormattingToolbar: false,
            showPlusMenu: false,
            activeMsgMenu: null,
            reactionTargetId: null,
            showOptionsDropdown: false,
            isMuted: false,
            newMessage: '',
            searchQuery: '',
            searchResults: [],
            inChatSearchOpen: false,
            inChatSearchQuery: '',
            inChatMatchIds: [],
            inChatActiveMatchIndex: -1,
            isMobileViewport: false,
            viewportMq: null,
            selectedBuyer: this.getBuyerFromUrl() || this.buyers?.[0] || this.apartment.buyers?.[0] || { id: 1, firstname: 'Buyer', lastname: '1' },
            isRecording: false,
            recordingTime: '00:00',
            recordingInterval: null,
            recordedAudio: null,
            isPlayingAudio: false,
            selectedFiles: [],
            isDragging: false,
            mediaRecorder: null,
            audioChunks: [],
            audioPlayer: null,
            audioCurrentTime: 0,
            audioDuration: 0,
            isRecordingPaused: false,
            recordingSeconds: 0,
            isCancelled: false,
            replyingTo: null,
            editingMessageId: null,
            filesToUpload: [],
            selectedFileIndex: 0,
            showPreviewOverlay: false,
            fileCaption: '',
            activeAudioIds: {}, // { 'audio-el-ID': true/false }
            audioProgressMap: {},
            audioCurrentTimeMap: {},
            audioDurationMap: {},
            lightboxUrl: null,
            lightboxType: 'image', // 'image' or 'video'
            lightboxActiveIndex: -1,

            // Realtime chat (Node.js websocket)
            realtimeReady: false,
            isSending: false,
            thread: null,
            threadId: null,
            messages: [],
            socket: null,
            mediaTab: 'media', // 'media', 'docs', 'links'
            isLoadingMore: false,
            hasMoreMessages: true,
            hasMoreFutureMessages: false,
            pagination: null,
            isLoadingShared: false,
            onlineUserIds: [],
            isPartnerTyping: false,
            typingUserName: '',
            sharedContent: {
                media: [],
                docs: [],
                links: [],
                pagination: { media: 1, docs: 1, links: 1 },
                hasMore: { media: true, docs: true, links: true }
            },

            // Presence & Typing
            onlineUserIds: [],
            isPartnerTyping: false,
            typingTimeout: null,
            lastTypingEmit: 0,
            showScrollToBottom: false,
            expandedMessages: {}, // { messageId: true }
            showWebcamModal: false,
            webcamStream: null,
            capturedImage: null,
            webcamError: null,
            selectedDate: null, // YYYY-MM-DD
            totalSearchResults: 0,
            showReactionModal: false,
            activeReactionMessage: null,
            showMsgInfoModal: false,
            showDiscardModal: false,
            previewFile: null,
            activeAdvisorPopup: null,
            msgInfo: {
                message: null,
                seen_by: [],
                isLoading: false
            },
        };
    },
    watch: {
        '$page.url': {
            handler() {
                this.selectedBuyer = this.getBuyerFromUrl() || this.selectedBuyerForCurrentUser || this.selectedBuyer;
                this.initRealtime();
            }
        },
        activeSidebar(val) {
            if (val === 'media') {
                this.loadSharedContent(true);
            }
        },
        mediaTab() {
            this.loadSharedContent(true);
        },
        newMessage(newVal) {
            this.handleTyping();
        }
    },
    computed: {
        chatBuyers() {
            const buyers = Array.isArray(this.buyers) && this.buyers.length
                ? this.buyers
                : (this.apartment?.buyers || []);

            if (['manager', 'owner'].includes(this.$page.props.user.currentAgencyRole)) {
                return buyers;
            }

            return buyers.filter((buyer) => Number(buyer.user_id) === Number(this.$page.props.user.id));
        },
        selectedBuyerForCurrentUser() {
            return this.getBuyerFromUrl() || this.chatBuyers?.[0] || this.selectedBuyer;
        },
        canSendMessages() {
            return this.thread && !this.thread.is_disabled;
        },
        layoutComponent() {
            return this.is_advisor ? 'ApartmentLayout' : 'ClientApartmentLayout';
        },
        audioProgress() {
            if (!this.audioDuration) return 0;
            return (this.audioCurrentTime / this.audioDuration) * 100;
        },
        chatPartner() {
            if (['manager', 'owner'].includes(this.$page.props.user.currentAgencyRole)) {
                if (this.chatBuyers.length > 1) {
                    const aptName = typeof this.apartment.getDisplayName === "function" ? this.apartment.getDisplayName() : (this.apartment.name || this.apartment.number || 'Apartment');
                    return {
                        name: `${aptName}'s Buyers`,
                        role: 'Buyers',
                        title: 'Multiple Buyers',
                        avatar: 'https://ui-avatars.com/api/?name=Buyers&background=random',
                        is_multi: true
                    };
                }
                const buyer = this.chatBuyers[0] || this.selectedBuyer || {};
                const buyerName = [buyer.firstname, buyer.lastname].filter(Boolean).join(' ').trim() || 'Buyer';
                return {
                    name: buyerName,
                    role: 'Buyer',
                    title: 'Apt 402 Owner',
                    avatar: this.thread?.buyer_avatar || buyer.account?.profile_photo_url,
                    is_multi: false
                };
            } else {
                const advisorName = this.apartment?.advisor_name || this.apartment?.advisor || 'Consultant';
                const safeAdvisorName = advisorName.trim();
                return {
                    id: this.apartment?.advisor_user_id,
                    name: safeAdvisorName,
                    role: 'Consultant',
                    title: 'Project Architect',
                    avatar: this.thread?.advisor_avatar || this.apartment?.advisor_avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(safeAdvisorName)}&background=0D8ABC&color=fff`,
                    is_multi: false
                };
            }
        },
        partnerUserId() {
            if (this.is_advisor) {
                if (this.chatBuyers.length > 1) {
                    return null;
                }
                return this.chatBuyers[0]?.user_id || this.chatBuyers[0]?.id || this.selectedBuyer?.user_id || this.selectedBuyer?.id;
            } else {
                return this.apartment?.advisor_user_id || this.apartment?.advisor_id || this.apartment?.advisor?.user_id || this.apartment?.advisor?.id;
            }
        },
        onlineBuyersCount() {
            return (this.chatBuyers || []).filter(b => this.onlineUserIds.some(id => Number(id) === Number(b.user_id))).length;
        },
        onlineBuyerName() {
            if (this.onlineBuyersCount !== 1) return null;
            const onlineBuyer = this.chatBuyers.find(b => this.onlineUserIds.some(id => Number(id) === Number(b.user_id)));
            return onlineBuyer ? onlineBuyer.firstname : null;
        },
        isPartnerOnline() {
            if (['manager', 'owner'].includes(this.$page.props.user.currentAgencyRole) && this.chatBuyers.length > 1) {
                return this.onlineBuyersCount > 0;
            }
            const partnerId = Number(this.partnerUserId);
            return this.onlineUserIds.some(id => Number(id) === partnerId);
        },
        inChatMatchCount() {
            return this.inChatMatchIds.length;
        },
        sharedMedia() {
            const allAttachments = [];
            const links = [];

            (this.messages || []).forEach(m => {
                const senderName = Number(m.sender_user_id) === Number(this.$page.props.user.id) ? 'You' : (m.sender_name || this.chatPartner.name);

                if (m.attachments && Array.isArray(m.attachments)) {
                    m.attachments.forEach(a => {
                        const type = (a.kind === 'photo' || (a.mime_type && a.mime_type.startsWith('image/'))) ? 'image' :
                            (a.kind === 'video' || (a.mime_type && a.mime_type.startsWith('video/'))) ? 'video' :
                                (a.kind === 'audio' || (a.mime_type && a.mime_type.startsWith('audio/'))) ? 'audio' : 'document';
                        allAttachments.push({
                            ...a,
                            messageId: m.id,
                            sender_name: senderName,
                            sent_at: m.sent_at,
                            type: type
                        });
                    });
                }

                // Detect links in body
                if (m.body) {
                    const urlRegex = /(https?:\/\/[^\s]+)/g;
                    if (urlRegex.test(m.body)) {
                        links.push({
                            id: m.id,
                            body: m.body,
                            sender_name: senderName,
                            sent_at: m.sent_at,
                            attachments: m.attachments || []
                        });
                    }
                }
            });

            const localPhotos = allAttachments.filter(a => a.kind === 'photo' || (a.mime_type && a.mime_type.startsWith('image/')));
            const localVideos = allAttachments.filter(a => a.kind === 'video' || (a.mime_type && a.mime_type.startsWith('video/')));
            const localAudios = allAttachments.filter(a => a.kind === 'audio' || (a.mime_type && a.mime_type.startsWith('audio/')));
            const localDocs = allAttachments.filter(a => !['photo', 'video', 'audio'].includes(a.kind) && (!a.mime_type || (!a.mime_type.startsWith('image/') && !a.mime_type.startsWith('video/') && !a.mime_type.startsWith('audio/'))));

            // Merge with fetched shared content
            const allMediaItems = [
                ...localPhotos, ...localVideos, ...localAudios,
                ...this.sharedContent.media.filter(a => !allAttachments.some(la => la.id === a.id))
            ].sort((a, b) => new Date(b.sent_at) - new Date(a.sent_at));

            const allDocs = [
                ...localDocs,
                ...this.sharedContent.docs.filter(a => !allAttachments.some(la => la.id === a.id))
            ].sort((a, b) => new Date(b.sent_at) - new Date(a.sent_at));

            const allLinks = [
                ...links,
                ...this.sharedContent.links.filter(a => !links.some(l => l.id === a.id))
            ].sort((a, b) => new Date(b.sent_at) - new Date(a.sent_at));

            // Group media (photos + videos + audios) by month
            const groupedMedia = {};
            allMediaItems.forEach(item => {
                const date = new Date(item.sent_at);
                const monthYear = date.toLocaleString('default', { month: 'long', year: 'numeric' }).toUpperCase();
                const now = new Date();
                let label = monthYear;
                if (date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()) {
                    label = 'THIS MONTH';
                }
                if (!groupedMedia[label]) groupedMedia[label] = [];
                groupedMedia[label].push(item);
            });

            return {
                groupedMedia,
                docs: allDocs,
                links: allLinks,
                counts: {
                    media: allMediaItems.length,
                    docs: allDocs.length,
                    links: allLinks.length
                }
            };
        },
        lightboxItems() {
            const items = [];
            (this.messages || []).forEach(m => {
                if (m.attachments && Array.isArray(m.attachments)) {
                    m.attachments.forEach(a => {
                        const isImage = a.kind === 'photo' || (a.mime_type && a.mime_type.startsWith('image/'));
                        const isVideo = a.kind === 'video' || (a.mime_type && a.mime_type.startsWith('video/'));
                        const isAudio = a.kind === 'audio' || (a.mime_type && a.mime_type.startsWith('audio/'));

                        if (isImage || isVideo || isAudio) {
                            items.push({
                                ...a,
                                messageId: m.id,
                                body: m.body,
                                type: isImage ? 'image' : (isVideo ? 'video' : 'audio')
                            });
                        }
                    });
                }
            });
            // Order them by the order they appear in chat (oldest first or newest first depending on user preference, typically newest first in lightboxes like this)
            return items.reverse();
        },
        groupedMessages() {
            const groups = [];
            let currentGroup = null;

            (this.messages || []).forEach(m => {
                if (!m.sent_at) return;
                // Use ISO date part (YYYY-MM-DD) for stable grouping and IDs
                const isoDate = m.sent_at.split(' ')[0].split('T')[0];
                if (!currentGroup || currentGroup.date !== isoDate) {
                    currentGroup = {
                        date: isoDate,
                        readableDate: this.formatDateLabel(m.sent_at),
                        messages: []
                    };
                    groups.push(currentGroup);
                }
                currentGroup.messages.push(m);
            });

            return groups;
        },
    },
    mounted() {
        window.addEventListener('click', this.handleGlobalClick);
        document.addEventListener('mousedown', this.handleClickOutside);
        this.selectedBuyer = this.selectedBuyerForCurrentUser;

        this.setupViewportListener();
        if (!this.isMobileViewport) {
            this.activeSidebar = 'media';
        }

        this.$nextTick(() => {
            this.scrollToBottom();
        });

        this.initRealtime();
    },
    beforeUnmount() {
        window.removeEventListener('click', this.handleGlobalClick);
        document.removeEventListener('mousedown', this.handleClickOutside);
        clearInterval(this.recordingInterval);
        this.teardownViewportListener();
        if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer = null;
        }
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    },
    methods: {
        getCommonSocketPayload(extra = {}) {
            const senderName = `${this.$page.props.user.firstname} ${this.$page.props.user.lastname}`.trim();
            return {
                thread_id: this.threadId,
                thread_uuid: this.thread?.uuid || null,
                sender_name: senderName,
                sender_id: this.$page.props.user.id,
                apartment_id: this.apartment.id,
                apartment_uuid: this.apartment.uuid,
                project_id: this.project.id,
                project_name: this.project.name,
                apartment_name: typeof this.apartment.getDisplayName === "function" ? this.apartment.getDisplayName() : (this.apartment.name || this.apartment.number || ""),
                buyer_id: this.selectedBuyer?.id || null,
                reply_to_message_id: this.replyingTo?.id || null,
                ...extra,
            };
        },
        handleTyping() {
            if (!this.socket || !this.threadId) return;

            const now = Date.now();
            if (now - this.lastTypingEmit > 2000) {
                this.socket.emit("typing", { thread_id: this.threadId, is_typing: true });
                this.lastTypingEmit = now;
            }

            if (this.typingTimeout) clearTimeout(this.typingTimeout);
            this.typingTimeout = setTimeout(() => {
                this.socket.emit("typing", { thread_id: this.threadId, is_typing: false });
            }, 3000);
        },
        async initRealtime() {
            try {
                this.realtimeReady = false;
                this.messages = [];
                this.thread = null;
                this.threadId = null;
                // Reset read-sync guard: message ids are global, so a value from a
                // previously opened thread must not suppress syncing in this one.
                this._lastSyncedReadId = 0;
                this._pendingReadId = 0;
                this._readSyncInFlight = false;

                await this.ensureThread();
                await this.connectSocket();
                await this.loadMessages();
                await this.loadThreadSettings();

                this.realtimeReady = true;
                this.markThreadRead();
                this.$nextTick(() => this.scrollToBottom());
            } catch (e) {
                console.error("Realtime init failed", e);
                this.realtimeReady = false;
            }
        },
        chatRouteName(nameForManager, nameForBuyer) {
            return ['manager', 'owner'].includes(this.$page.props.user.currentAgencyRole)
                ? nameForManager
                : nameForBuyer;
        },
        chatBasePrefix() {
            return ['manager', 'owner'].includes(this.$page.props.user.currentAgencyRole) ? '/a' : '/c';
        },
        async ensureThread() {
            const base = this.chatBasePrefix();
            const res = await window.axios.get(
                `${base}/apartments/${this.apartment.uuid}/buyers/${this.selectedBuyer.id}/chat/thread`
            );
            this.thread = res.data.thread;
            this.threadId = res.data.thread?.id;
        },
        async loadMessages() {
            if (!this.threadId || !this.thread) return;
            const base = this.chatBasePrefix();
            const res = await window.axios.get(
                `${base}/apartments/chat/threads/${this.thread.uuid}/messages`,
                { params: { per_page: 20 } }
            );

            // API returns newest-first; store oldest-first for rendering
            const msgs = (res.data.messages?.data || res.data.messages || []);
            this.messages = Array.isArray(msgs) ? msgs.slice().reverse() : [];
            this.pagination = res.data.pagination;
            this.hasMoreMessages = !!res.data.pagination?.has_more_before;
            this.hasMoreFutureMessages = !!res.data.pagination?.has_more_after;

            // Fallback for older API versions
            if (typeof res.data.pagination?.has_more_before === 'undefined') {
                this.hasMoreMessages = !!res.data.pagination?.has_more;
                this.hasMoreFutureMessages = false;
            }

            if (res.data.thread) {
                this.thread = res.data.thread;
            }

            // Keep the active reaction message reference updated if modal is open
            if (this.activeReactionMessage) {
                const updated = this.getMessageById(this.activeReactionMessage.id);
                if (updated) {
                    this.activeReactionMessage = updated;
                }
            }
        },
        async loadMoreMessages() {
            if (this.isLoadingMore || !this.hasMoreMessages || !this.messages.length) return;
            this.isLoadingMore = true;

            const firstMsgId = this.messages[0].id;
            const base = this.chatBasePrefix();

            try {
                const res = await window.axios.get(
                    `${base}/apartments/chat/threads/${this.thread.uuid}/messages`,
                    { params: { per_page: 20, before_id: firstMsgId } }
                );

                const msgs = (res.data.messages?.data || res.data.messages || []);
                if (msgs.length > 0) {
                    // Record scroll height before adding messages
                    const container = this.$refs.chatContainer;
                    const oldScrollHeight = container.scrollHeight;

                    // msgs is newest-first (API), so reverse it to get oldest-first to prepend
                    const reversed = msgs.slice().reverse();
                    this.messages = [...reversed, ...this.messages];

                    if (typeof res.data.pagination?.has_more_before !== 'undefined') {
                        this.hasMoreMessages = !!res.data.pagination?.has_more_before;
                    } else {
                        this.hasMoreMessages = !!res.data.pagination?.has_more;
                    }

                    // Maintain scroll position
                    this.$nextTick(() => {
                        container.scrollTop = container.scrollHeight - oldScrollHeight;
                    });
                } else {
                    this.hasMoreMessages = false;
                }
            } catch (e) {
                console.error("Failed to load more messages", e);
            } finally {
                this.isLoadingMore = false;
            }
        },
        async loadMoreFutureMessages() {
            if (this.isLoadingMore || !this.hasMoreFutureMessages || !this.messages.length) return;
            this.isLoadingMore = true;

            const lastMsgId = this.messages[this.messages.length - 1].id;
            const base = this.chatBasePrefix();

            try {
                const res = await window.axios.get(
                    `${base}/apartments/chat/threads/${this.thread.uuid}/messages`,
                    { params: { per_page: 20, after_id: lastMsgId } }
                );

                const msgs = (res.data.messages?.data || res.data.messages || []);
                if (msgs.length > 0) {
                    // msgs is oldest-first (API returned asc for after_id)
                    // but wait, my API implementation for after_id uses orderBy('sent_at', 'asc')
                    // so it returns 11, 12, 13...
                    // The frontend expects messages to be oldest-at-top, newest-at-bottom.
                    // So we just append them.
                    this.messages = [...this.messages, ...msgs];
                    this.hasMoreFutureMessages = !!res.data.pagination?.has_more_after;
                } else {
                    this.hasMoreFutureMessages = false;
                }
            } catch (e) {
                console.error("Failed to load more future messages", e);
            } finally {
                this.isLoadingMore = false;
            }
        },
        async connectSocket() {
            const base = this.chatBasePrefix();
            const tokenRes = await window.axios.post(`${base}/apartments/chat/socket-token`);
            const token = tokenRes.data.token;

            const socketUrl = this.$page.props.chat_socket_url;

            if (this.socket) {
                this.socket.disconnect();
                this.socket = null;
            }

            this.socket = io(socketUrl, {
                transports: ["websocket"],
                auth: { token },
            });

            this.socket.on("connect", () => {
                if (!this.threadId) return;
                console.log("Joined thread room:", this.threadId);
                this.socket.emit("thread.join", { thread_id: this.threadId }, (res) => {
                    if (res && res.online_user_ids) {
                        this.onlineUserIds = res.online_user_ids;
                    }
                });
                this.markThreadRead();
            });

            this.socket.on("connect_error", async (err) => {
                console.error("Socket connect_error:", err.message);
                if (err.message?.includes("auth") || err.message?.includes("token")) {
                    await this.connectSocket();
                }
            });

            this.socket.on("disconnect", (reason) => {
                console.log("Socket disconnected:", reason);
            });

            this.socket.on("message.created", async (evt) => {
                if ((evt?.thread_id || evt?.threadId) !== this.threadId) return;

                const senderId = Number(evt.sender_id || evt.senderId);

                try {
                    await this.loadMessages();
                    this.markThreadRead();
                    this.$nextTick(() => this.scrollToBottom());
                } catch (e) {
                    const status = e?.response?.status;
                    if (status === 401 || status === 403) {
                        try {
                            if (this.socket) {
                                this.socket.disconnect();
                            }
                        } catch (_err) {
                            // ignore
                        }

                        this.socket = null;
                        this.realtimeReady = false;

                        if (typeof this.$notify === "function") {
                            this.$notify(
                                {
                                    group: "success",
                                    title: "Chat access removed",
                                    text: "This apartment is no longer assigned to you.",
                                    url: null,
                                },
                                4000,
                            );
                        }

                        this.$inertia.get(this.route("advisors.projects.index"));
                        return;
                    }

                    throw e;
                }
            });

            this.socket.on("message.reaction_changed", async (evt) => {
                if ((evt?.thread_id || evt?.threadId) !== this.threadId) return;
                await this.loadMessages();
            });

            this.socket.on("message.updated", async (evt) => {
                console.log("Socket: message.updated", evt);
                if (Number(evt?.thread_id || evt?.threadId) !== Number(this.threadId)) return;
                await this.loadMessages();
            });

            this.socket.on("message.edited", async (evt) => {
                console.log("Socket: message.edited", evt);
                if (Number(evt?.thread_id || evt?.threadId) !== Number(this.threadId)) return;
                await this.loadMessages();
            });

            this.socket.on("message.update", async (evt) => {
                console.log("Socket: message.update", evt);
                if (Number(evt?.thread_id || evt?.threadId) !== Number(this.threadId)) return;
                await this.loadMessages();
            });

            this.socket.on("thread.updated", async (evt) => {
                console.log("Socket: thread.updated", evt);
                if (Number(evt?.thread_id || evt?.threadId) !== Number(this.threadId)) return;
                await this.loadMessages();
            });

            this.socket.on("thread.read_changed", async (evt) => {
                if ((evt?.thread_id || evt?.threadId) !== this.threadId) return;
                // If the OTHER user read our messages, update the partner read cursor
                if (Number(evt.user_id) !== Number(this.$page.props.user.id)) {
                    if (this.thread) {
                        // Whenever someone else reads, we re-fetch the collective status from the backend.
                        // This ensures that complex "all-partners-read" logic (like blue ticks in group chats)
                        // is always calculated accurately by the source of truth.
                        try {
                            const base = this.chatBasePrefix();
                            const res = await window.axios.get(`${base}/apartments/chat/threads/${this.thread.uuid}/identify`);
                            if (res.data?.ok && res.data.thread) {
                                this.thread.partner_last_read_message_id = res.data.thread.partner_last_read_message_id;
                            }
                        } catch (e) {
                            console.error("Failed to re-sync thread status", e);
                        }
                    }
                }
            });

            this.socket.on("presence.update", (evt) => {
                this.onlineUserIds = evt.online_user_ids || [];
            });

            this.socket.on("typing", (evt) => {
                const isTyping = !!evt.is_typing;

                if (['manager', 'owner'].includes(this.$page.props.user.currentAgencyRole) && this.chatBuyers.length > 1) {
                    const typingBuyer = this.chatBuyers.find(b => Number(b.user_id) === Number(evt.user_id));
                    if (typingBuyer) {
                        this.isPartnerTyping = isTyping;
                        this.typingUserName = isTyping ? (typingBuyer.firstname || 'Buyer') : '';
                    }
                } else if (Number(evt.user_id) === Number(this.partnerUserId)) {
                    this.isPartnerTyping = isTyping;
                    this.typingUserName = isTyping ? this.chatPartner.name : '';
                }
            });

            this.socket.on("thread.updated", (evt) => {
                if (Number(evt.thread_id) === Number(this.threadId)) {
                    if (typeof evt.is_disabled !== 'undefined') {
                        this.thread.is_disabled = !!evt.is_disabled;

                        // Redirect buyer if chat is disabled
                        if (this.thread.is_disabled && !this.is_advisor) {
                            Inertia.visit(this.route('clients.apartments.show', { apartment: this.apartment.uuid }));
                        }
                    }
                }
            });
        },
        setupViewportListener() {
            if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
            // Match Tailwind md breakpoint-ish (mobile <= 768px in this file's CSS)
            this.viewportMq = window.matchMedia('(max-width: 768px)');
            this.isMobileViewport = !!this.viewportMq.matches;

            const handler = (e) => {
                this.isMobileViewport = !!e.matches;
                this.onViewportChanged();
            };

            // Keep a reference so we can remove it
            this._viewportHandler = handler;

            if (typeof this.viewportMq.addEventListener === 'function') {
                this.viewportMq.addEventListener('change', handler);
            } else if (typeof this.viewportMq.addListener === 'function') {
                this.viewportMq.addListener(handler);
            }
        },
        teardownViewportListener() {
            if (!this.viewportMq || !this._viewportHandler) return;
            if (typeof this.viewportMq.removeEventListener === 'function') {
                this.viewportMq.removeEventListener('change', this._viewportHandler);
            } else if (typeof this.viewportMq.removeListener === 'function') {
                this.viewportMq.removeListener(this._viewportHandler);
            }
            this.viewportMq = null;
            this._viewportHandler = null;
        },
        onViewportChanged() {
            // If user was using the sidebar search and switches to mobile,
            // automatically move them to "Search in chat" with the same query.
            if (this.isMobileViewport && this.activeSidebar === 'search') {
                const q = (this.searchQuery || '').trim();
                this.activeSidebar = null;
                this.openInChatSearch();
                if (q) {
                    this.inChatSearchQuery = q;
                    this.$nextTick(() => this.updateInChatSearch({ jumpToFirst: true }));
                }
            }

            // If user was using "Search in chat" and switches to desktop,
            // automatically move them to the sidebar search with the same query.
            if (!this.isMobileViewport && this.inChatSearchOpen) {
                const q = (this.inChatSearchQuery || '').trim();
                this.closeInChatSearch();
                this.activeSidebar = 'search';
                if (q) {
                    this.searchQuery = q;
                    this.handleSearch();
                } else {
                    this.searchQuery = '';
                    this.searchResults = [];
                }
            }
        },
        getAllMessagesForSearch() {
            return (this.messages || []).map((m) => ({
                id: m.id,
                sender: m.sender_user_id === this.$page.props.user.id ? 'You' : (m.sender_name || this.chatPartner.name),
                text: (m.body || (m.attachments?.[0]?.original_name || '')).toString(),
                date: m.sent_at || '',
            }));
        },
        openInChatSearch() {
            this.inChatSearchOpen = true;
            this.$nextTick(() => {
                const input = this.$refs.inChatSearchInput;
                if (input && typeof input.focus === 'function') input.focus();
                this.updateInChatSearch({ jumpToFirst: false });
            });
        },
        closeInChatSearch() {
            this.inChatSearchOpen = false;
            this.inChatSearchQuery = '';
            this.inChatMatchIds = [];
            this.inChatActiveMatchIndex = -1;
            this.applyInChatSearchHighlights();
        },
        updateInChatSearch({ jumpToFirst } = { jumpToFirst: false }) {
            const q = (this.inChatSearchQuery || '').trim().toLowerCase();
            if (!q) {
                this.inChatMatchIds = [];
                this.inChatActiveMatchIndex = -1;
                this.applyInChatSearchHighlights();
                return;
            }

            const matches = this.getAllMessagesForSearch()
                .filter(m => {
                    const normalizedText = (m.text || '').toLowerCase().replace(/\s+/g, ' ');
                    const normalizedSender = (m.sender || '').toLowerCase().replace(/\s+/g, ' ');
                    const matchesQuery = normalizedText.includes(q) || normalizedSender.includes(q);

                    if (!this.selectedDate) return matchesQuery;

                    const msgDate = (m.date || '').split(' ')[0].split('T')[0];
                    return matchesQuery && msgDate === this.selectedDate;
                })
                .map(m => m.id)
                .filter(id => document.getElementById(`msg-${id}`));

            this.inChatMatchIds = matches;
            this.inChatActiveMatchIndex = matches.length ? 0 : -1;
            this.applyInChatSearchHighlights();

            if (jumpToFirst && matches.length) {
                this.goToInChatMatch(0);
            }
        },
        applyInChatSearchHighlights() {
            const root = this.$refs.chatContainer;
            if (!root) return;

            const prev = root.querySelectorAll('.chat-search-match, .chat-search-active');
            prev.forEach(el => el.classList.remove('chat-search-match', 'chat-search-active'));

            this.inChatMatchIds.forEach((id) => {
                const el = document.getElementById(`msg-${id}`);
                if (el) el.classList.add('chat-search-match');
            });

            if (this.inChatActiveMatchIndex >= 0 && this.inChatActiveMatchIndex < this.inChatMatchIds.length) {
                const activeId = this.inChatMatchIds[this.inChatActiveMatchIndex];
                const activeEl = document.getElementById(`msg-${activeId}`);
                if (activeEl) activeEl.classList.add('chat-search-active');
            }
        },
        goToInChatMatch(idx) {
            if (!this.inChatMatchIds.length) return;
            const nextIdx = Math.max(0, Math.min(idx, this.inChatMatchIds.length - 1));
            this.inChatActiveMatchIndex = nextIdx;
            this.applyInChatSearchHighlights();
            this.scrollToMessage(this.inChatMatchIds[nextIdx]);
        },
        nextInChatMatch() {
            if (!this.inChatMatchIds.length) return;
            const idx = this.inChatActiveMatchIndex < 0 ? 0 : (this.inChatActiveMatchIndex + 1) % this.inChatMatchIds.length;
            this.goToInChatMatch(idx);
        },
        prevInChatMatch() {
            if (!this.inChatMatchIds.length) return;
            const idx = this.inChatActiveMatchIndex < 0
                ? 0
                : (this.inChatActiveMatchIndex - 1 + this.inChatMatchIds.length) % this.inChatMatchIds.length;
            this.goToInChatMatch(idx);
        },
        scrollToBottom(behavior = 'auto') {
            const el = this.$refs.chatContainer;
            if (el) {
                el.scrollTo({ top: el.scrollHeight, behavior });
            }
        },
        handleGlobalClick(event) {
            // Close message menu if clicking outside
            if (this.activeMsgMenu && !event.target.closest('.relative')) {
                this.activeMsgMenu = null;
            }
            // Close options dropdown if clicking outside
            if (this.showOptionsDropdown && !event.target.closest('.relative')) {
                this.showOptionsDropdown = false;
            }
        },
        handleClickOutside(event) {
            // Close plus menu if clicking outside
            if (this.showPlusMenu && !event.target.closest('button')) {
                const menu = document.querySelector('.absolute.bottom-full.mb-4.left-0');
                if (menu && !menu.contains(event.target)) {
                    this.showPlusMenu = false;
                }
            }
            // Close emoji picker if clicking outside
            if (this.showEmojiPicker) {
                if (!event.target.closest('.emoji-picker-container') &&
                    !event.target.closest('button') &&
                    !event.target.closest('input')) {
                    this.showEmojiPicker = false;
                }
            }
            // Close message menus
            if (this.activeMsgMenu !== null) {
                // If click is not on a toggle button AND not inside a menu component
                if (!event.target.closest('button[id^="toggle-menu-"]') && !event.target.closest('.absolute.mt-1.w-48')) {
                    this.activeMsgMenu = null;
                }
            }
            // Close header dropdowns
            if (this.showBuyerDropdown || this.showOptionsDropdown) {
                if (!event.target.closest('button')) {
                    this.showBuyerDropdown = false;
                    this.showOptionsDropdown = false;
                }
            }
        },
        onDragOver() {
            this.isDragging = true;
        },
        onDragLeave(event) {
            if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) return;
            this.isDragging = false;
        },
        onDrop(event) {
            this.isDragging = false;
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                // Manually trigger handleFileSelect logic with dropped file
                this.handleFileSelect({ target: { files: files } });
            }
        },
        onPaste(event) {
            const items = (event.clipboardData || event.originalEvent?.clipboardData)?.items;
            if (!items) return;
            const files = [];
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf("image") !== -1) {
                    const blob = items[i].getAsFile();
                    if (blob) files.push(blob);
                }
            }
            if (files.length > 0) {
                event.preventDefault();
                this.handleFiles(files);
            }
        },
        getBuyerFromUrl() {
            if (this.$page.props.user.currentAgencyRole === 'manager') {
                const params = new URLSearchParams(window.location.search);
                const encodedBuyerId = params.get('buyer');
                if (encodedBuyerId) {
                    const buyerId = this.decodeId(encodedBuyerId);
                    if (buyerId) {
                        return this.chatBuyers?.find(b => b.id == buyerId);
                    }
                }
            }
            return null;
        },
        encodeId(id) {
            return encodeBuyerId(id);
        },
        decodeId(encoded) {
            return decodeBuyerId(encoded);
        },
        async loadThreadSettings() {
            if (!this.threadId || !this.thread) return;
            const base = this.chatBasePrefix();
            try {
                const res = await window.axios.get(`${base}/apartments/chat/threads/${this.thread.uuid}/settings`);
                this.isMuted = !!res.data?.settings?.is_muted;
            } catch (e) {
                console.error("Failed fetching mute settings", e);
            }
        },
        async toggleMute() {
            if (!this.threadId || !this.thread) return;
            const newMuteStatus = !this.isMuted;
            this.isMuted = newMuteStatus;

            // Sync with localStorage so Layout can react immediately
            try {
                const mutedThreads = JSON.parse(localStorage.getItem('chat_muted_threads') || '{}');
                if (newMuteStatus) mutedThreads[this.threadId] = true;
                else delete mutedThreads[this.threadId];
                localStorage.setItem('chat_muted_threads', JSON.stringify(mutedThreads));
            } catch (e) { /* ignore */ }

            const base = this.chatBasePrefix();
            try {
                await window.axios.post(`${base}/apartments/chat/threads/${this.thread.uuid}/toggle-mute`, {
                    is_muted: newMuteStatus
                });
            } catch (e) {
                console.error("Failed toggling mute status", e);
                this.isMuted = !newMuteStatus; // Rollback
            }
        },
        async markAsUnread() {
            if (!this.thread) return;
            const base = this.chatBasePrefix();
            try {
                await window.axios.post(`${base}/apartments/chat/threads/${this.thread.uuid}/mark-unread`);
                this.$inertia.visit(this.route('advisors.apartments.show', { apartment: this.apartment.uuid }));
            } catch (e) {
                console.error("Failed marking thread as unread", e);
            }
        },
        selectBuyer(buyer) {
            if (Number(this.selectedBuyer?.id) === Number(buyer.id)) {
                this.showBuyerDropdown = false;
                return;
            }
            this.showBuyerDropdown = false;

            const params = { apartment: this.apartment.uuid };
            if (this.chatBuyers?.length > 1) {
                params.buyer = this.encodeId(buyer.id);
            }

            this.$inertia.get(this.route(this.route().current(), params), {}, {
                preserveScroll: true,
                preserveState: true
            });
        },
        toggleSidebar(type) {
            // Close header dropdowns whenever switching sidebars
            this.showOptionsDropdown = false;
            this.showBuyerDropdown = false;
            if (this.activeSidebar === type) {
                this.activeSidebar = null;
            } else {
                this.activeSidebar = type;
            }
        },
        async handleSearch() {
            const query = (this.searchQuery || '').trim().toLowerCase();
            if (!query && !this.selectedDate) {
                this.searchResults = [];
                return;
            }

            // Local search first for speed
            const localResults = this.getAllMessagesForSearch().filter(msg => {
                const normalizedText = (msg.text || '').toLowerCase().replace(/\s+/g, ' ');
                const normalizedSender = (msg.sender || '').toLowerCase().replace(/\s+/g, ' ');
                const matchesQuery = normalizedText.includes(query) || normalizedSender.includes(query);

                if (!this.selectedDate) return matchesQuery;

                const msgDate = (msg.date || '').split(' ')[0].split('T')[0];
                return matchesQuery && msgDate === this.selectedDate;
            });
            this.searchResults = localResults;

            // Full backend search
            const base = this.chatBasePrefix();
            try {
                const res = await window.axios.get(
                    `${base}/apartments/chat/threads/${this.thread.uuid}/messages/search`,
                    { params: { query, date: this.selectedDate } }
                );

                const remoteMsgs = res.data.messages || [];
                // If we have a date filter and no results, and NO keyword, we might want to just show bottom
                if (remoteMsgs.length === 0 && this.selectedDate && !query) {
                    this.scrollToBottom('smooth');
                }

                const formattedRemote = remoteMsgs.map(m => ({
                    id: m.id,
                    sender: Number(m.sender_user_id) === Number(this.$page.props.user.id) ? 'You' : (m.sender_name || this.chatPartner.name),
                    text: (m.body || (m.attachments?.[0]?.original_name || '')).toString(),
                    date: m.sent_at || '',
                }));

                // Merge and unique
                const combined = [...localResults];
                const seenIds = new Set(localResults.map(r => r.id));

                formattedRemote.forEach(r => {
                    if (!seenIds.has(r.id)) {
                        combined.push(r);
                        seenIds.add(r.id);
                    }
                });

                this.searchResults = combined.sort((a, b) => new Date(b.date) - new Date(a.date));
            } catch (e) {
                console.error("Full search failed", e);
            }
        },
        async loadSharedContent(reset = false) {
            if (!this.threadId || !this.thread) return;
            const tab = this.mediaTab;
            if (reset) {
                this.sharedContent[tab] = [];
                this.sharedContent.pagination[tab] = 1;
                this.sharedContent.hasMore[tab] = true;
            }
            if (!this.sharedContent.hasMore[tab] || this.isLoadingShared) return;

            this.isLoadingShared = true;
            const base = this.chatBasePrefix();
            try {
                const res = await window.axios.get(
                    `${base}/apartments/chat/threads/${this.thread.uuid}/shared-content`,
                    { params: { kind: tab, page: this.sharedContent.pagination[tab] } }
                );

                // Handle both array and paginated response
                const rawMsgs = res.data.messages || [];
                const msgs = Array.isArray(rawMsgs) ? rawMsgs : (rawMsgs.data || []);
                const items = [];

                msgs.forEach(m => {
                    const senderName = Number(m.sender_user_id) === Number(this.$page.props.user.id) ? 'You' : (m.sender_name || this.chatPartner.name);
                    if (tab === 'links' && m.body) {
                        items.push({
                            id: m.id,
                            body: m.body,
                            sender_name: senderName,
                            sent_at: m.sent_at,
                            attachments: m.attachments || []
                        });
                    } else if (m.attachments) {
                        m.attachments.forEach(a => {
                            items.push({
                                ...a,
                                messageId: m.id,
                                sender_name: senderName,
                                sent_at: m.sent_at
                            });
                        });
                    }
                });

                this.sharedContent[tab] = [...this.sharedContent[tab], ...items];
                this.sharedContent.hasMore[tab] = res.data.pagination.current_page < res.data.pagination.last_page;
                if (this.sharedContent.hasMore[tab]) {
                    this.sharedContent.pagination[tab]++;
                }
            } catch (e) {
                console.error("Failed to load shared content", e);
            } finally {
                this.isLoadingShared = false;
            }
        },
        highlightText(text, query) {
            if (!text) return '';
            const q = (query || '').trim();
            // Escape HTML for security
            let escaped = String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
            if (!q) return escaped;

            // Escape regex special characters
            const escapedQuery = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
            const regex = new RegExp(`(${escapedQuery})`, 'gi');
            return escaped.replace(regex, '<span class="bg-blue-100 text-blue-800 font-bold px-0.5 rounded">$1</span>');
        },
        async scrollToMessage(id) {
            let element = document.getElementById(`msg-${id}`);
            if (!element) {
                const base = this.chatBasePrefix();
                try {
                    const res = await window.axios.get(
                        `${base}/apartments/chat/threads/${this.thread.uuid}/messages`,
                        { params: { around_id: id } }
                    );

                    if (res.data.ok) {
                        const msgs = (res.data.messages || []);
                        // API returns newest-first; store oldest-first
                        this.messages = Array.isArray(msgs) ? msgs.slice().reverse() : [];
                        this.hasMoreMessages = !!res.data.pagination?.has_more_before;
                        this.hasMoreFutureMessages = !!res.data.pagination?.has_more_after;

                        await this.$nextTick();
                        element = document.getElementById(`msg-${id}`);
                    }
                } catch (e) {
                    console.error("Failed to load message context", e);
                    return;
                }
            }

            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                element.classList.add('bg-blue-50/50');
                setTimeout(() => {
                    element.classList.remove('bg-blue-50/50');
                }, 2000);
            }
        },
        async handleDateChange(date) {
            this.selectedDate = date;

            // If search query exists or sidebar is 'search' mode, update sidebar search results
            if ((this.searchQuery && this.searchQuery.trim().length >= 2) || this.activeSidebar === 'search') {
                this.handleSearch();
            }

            // Update in-chat search if active (mobile/WhatsApp style)
            if (this.inChatSearchOpen) {
                this.updateInChatSearch({ jumpToFirst: true });
            }

            // Always try to jump to the date in the main chat too
            await this.jumpToDate(date);
        },
        clearDateFilter() {
            this.selectedDate = null;

            // Update sidebar search results
            if ((this.searchQuery && this.searchQuery.trim().length >= 2) || this.activeSidebar === 'search') {
                this.handleSearch();
            }

            // Update in-chat search if active
            if (this.inChatSearchOpen) {
                this.updateInChatSearch({ jumpToFirst: true });
            }

            if (!this.searchQuery && !this.activeSidebar && !this.inChatSearchOpen) {
                this.searchResults = [];
                this.scrollToBottom('smooth');
            }
        },
        async jumpToDate(date) {
            const element = document.getElementById(`date-${date}`);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                // Add a temporary highlight effect to the date separator
                const span = element.querySelector('span');
                if (span) {
                    span.classList.add('ring-4', 'ring-blue-500/20');
                    setTimeout(() => {
                        span.classList.remove('ring-4', 'ring-blue-500/20');
                    }, 2000);
                }
            } else {
                console.log('No messages found locally for date:', date, 'fetching from server...');
                await this.fetchAroundDate(date);
            }
        },
        async fetchAroundDate(date) {
            if (this.isLoadingMore) return;
            this.isLoadingMore = true;
            const base = this.chatBasePrefix();
            try {
                const res = await window.axios.get(
                    `${base}/apartments/chat/threads/${this.thread.uuid}/messages`,
                    { params: { around_date: date } }
                );

                const msgs = (res.data.messages?.data || res.data.messages || []);
                if (msgs.length > 0) {
                    // Replace existing messages with the ones around the target date
                    this.messages = Array.isArray(msgs) ? msgs.slice().reverse() : [];
                    this.pagination = res.data.pagination;
                    this.hasMoreMessages = !!res.data.pagination?.has_more_before;
                    this.hasMoreFutureMessages = !!res.data.pagination?.has_more_after;

                    this.$nextTick(() => {
                        const el = document.getElementById(`date-${date}`);
                        if (el) {
                            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            const span = el.querySelector('span');
                            if (span) {
                                span.classList.add('ring-4', 'ring-blue-500/20');
                                setTimeout(() => span.classList.remove('ring-4', 'ring-blue-500/20'), 2000);
                            }
                        } else {
                            // If exactly that date doesn't exist, the backend fell back to nearest.
                            // We scroll to top or bottom depending on context, or just let it stay.
                            this.scrollToBottom();
                        }
                    });
                }
            } catch (e) {
                console.error("Jump to date failed", e);
            } finally {
                this.isLoadingMore = false;
            }
        },
        openEmojiPickerForReaction(id) {
            this.reactionTargetId = id;
            this.showEmojiPicker = true;
            this.activeMsgMenu = null;
        },
        insertNewline() {
            const input = this.$refs.messageInput;
            if (input) {
                // For contenteditable, we use execCommand to insert a line break at the cursor
                document.execCommand('insertLineBreak');
                this.handleInput();
            } else {
                this.newMessage += "\n";
            }
        },
        autoResize() {
            const input = this.$refs.messageInput;
            if (input) {
                input.style.height = 'auto'; // Reset height to recalculate
                input.style.height = Math.min(input.scrollHeight, 128) + 'px'; // 128px is max-h-32
            }
        },
        onSelectEmoji(emoji) {
            if (this.reactionTargetId) {
                this.reactToMessage(this.reactionTargetId, emoji.i);
                this.reactionTargetId = null;
                this.showEmojiPicker = false;
            } else {
                const input = this.$refs.messageInput;
                if (input) {
                    // For contenteditable, we use execCommand to insert text at the cursor
                    input.focus();
                    document.execCommand('insertText', false, emoji.i);
                    this.handleInput();
                } else {
                    this.newMessage += emoji.i;
                }
            }
        },
        async startVoiceRecord() {
            try {
                this.isCancelled = false;
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                this.mediaRecorder = new MediaRecorder(stream);
                this.audioChunks = [];

                this.mediaRecorder.ondataavailable = (event) => {
                    this.audioChunks.push(event.data);
                };

                this.mediaRecorder.onstop = () => {
                    if (this.isCancelled) {
                        this.isCancelled = false;
                        return;
                    }
                    const audioBlob = new Blob(this.audioChunks, { type: 'audio/mpeg' });
                    this.recordedAudio = {
                        blob: audioBlob,
                        url: URL.createObjectURL(audioBlob)
                    };
                    this.audioPlayer = new Audio(this.recordedAudio.url);

                    this.audioPlayer.onloadedmetadata = () => {
                        this.audioDuration = this.audioPlayer.duration;
                    };

                    this.audioPlayer.ontimeupdate = () => {
                        this.audioCurrentTime = this.audioPlayer.currentTime;
                    };

                    this.audioPlayer.onended = () => {
                        this.isPlayingAudio = false;
                        this.audioCurrentTime = 0;
                    };
                };

                this.mediaRecorder.start();
                this.isRecording = true;
                this.isRecordingPaused = false;
                this.recordingSeconds = 0;
                this.startRecordingTimer();
            } catch (err) {
                console.error('Error accessing microphone:', err);
                alert('Could not access microphone. Please check permissions.');
            }
        },
        startRecordingTimer() {
            clearInterval(this.recordingInterval);
            this.recordingInterval = setInterval(() => {
                this.recordingSeconds++;
                this.recordingTime = this.formatAudioTime(this.recordingSeconds);
            }, 1000);
        },
        pauseVoiceRecord() {
            if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
                this.mediaRecorder.pause();
                this.isRecordingPaused = true;
                clearInterval(this.recordingInterval);
            }
        },
        resumeVoiceRecord() {
            if (this.mediaRecorder && this.mediaRecorder.state === 'paused') {
                this.mediaRecorder.resume();
                this.isRecordingPaused = false;
                this.startRecordingTimer();
            }
        },
        stopRecording() {
            if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
                this.mediaRecorder.stop();
                this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
            }
            clearInterval(this.recordingInterval);
            this.isRecording = false;
            this.isRecordingPaused = false;
        },
        cancelRecording() {
            this.isCancelled = true;
            this.stopRecording();
            if (this.audioPlayer) {
                this.audioPlayer.pause();
                this.audioPlayer = null;
            }
            this.recordingTime = '00:00';
            this.recordedAudio = null;
            this.isPlayingAudio = false;
        },
        async sendVoiceMessage() {
            if (!this.recordedAudio || !this.recordedAudio.blob) {
                this.cancelRecording();
                return;
            }

            this.isSending = true;

            const file = new File([this.recordedAudio.blob], "voice_message.webm", { type: "audio/webm" });

            const maxAudioMb = this.$page.props.chat_msg_audio_upload_max_size_in_mb || 20;
            if (file.size > maxAudioMb * 1024 * 1024) {
                if (typeof this.$notify === 'function') {
                    this.$notify({
                        group: "error",
                        title: "Voice message too large",
                        text: `Voice message is too large. Max size is ${maxAudioMb}MB.`
                    }, 5000);
                } else {
                    alert(`Voice message is too large. Max size is ${maxAudioMb}MB.`);
                }
                this.isSending = false;
                return;
            }

            const formData = new FormData();
            formData.append("files[]", file);
            formData.append("captions[0]", "");
            formData.append("kinds[0]", "audio");

            const base = this.chatBasePrefix();
            try {
                const upRes = await window.axios.post(
                    `${base}/apartments/${this.apartment.uuid}/buyers/${this.selectedBuyer.id}/chat/upload`,
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                const attachments = upRes.data.uploads || [];

                this.socket.emit("message.send", this.getCommonSocketPayload({
                    body: null,
                    attachments: attachments,
                }), (ack) => {
                    if (ack?.ok) {
                        this.loadMessages();
                        this.$nextTick(() => this.scrollToBottom());
                    }
                });

                this.clearReply();
                this.cancelRecording();
            } catch (err) {
                console.error("Failed to upload voice message", err);
                const msg = err.response?.data?.error || err.response?.data?.message || "Failed to send voice message. Please try again.";
                if (typeof this.$notify === 'function') {
                    this.$notify({
                        group: "error",
                        title: "Upload Failed",
                        text: msg
                    }, 5000);
                } else {
                    alert(msg);
                }
            } finally {
                this.isSending = false;
            }
        },
        toggleRecordedAudio() {
            if (this.audioPlayer) {
                if (this.isPlayingAudio) {
                    this.audioPlayer.pause();
                } else {
                    this.audioPlayer.play();
                }
                this.isPlayingAudio = !this.isPlayingAudio;
            }
        },
        seekAudio(event) {
            if (!this.audioPlayer || !this.audioDuration) return;
            const rect = event.currentTarget.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const percent = x / rect.width;
            this.audioPlayer.currentTime = percent * this.audioDuration;
        },
        formatAudioTime(seconds) {
            if (isNaN(seconds)) return '0:00';
            const mins = Math.floor(seconds / 60);
            const secs = Math.floor(seconds % 60);
            return `${mins}:${secs.toString().padStart(2, '0')}`;
        },
        handleFileSelect(event) {
            const files = Array.from(event.target.files);
            if (files.length > 0) {
                this.handleFiles(files);
                event.target.value = '';
            }
        },
        handleFiles(files) {
            const limits = {
                image: this.$page.props.chat_msg_image_upload_max_size_in_mb || 20,
                video: this.$page.props.chat_msg_video_upload_max_size_in_mb || 50,
                audio: this.$page.props.chat_msg_audio_upload_max_size_in_mb || 20,
                other: this.$page.props.chat_msg_docs_upload_max_size_in_mb || 20
            };

            const validFiles = [];
            for (const file of files) {
                let kind = 'other';
                if (file.type.startsWith('image/')) kind = 'image';
                else if (file.type.startsWith('video/')) kind = 'video';
                else if (file.type.startsWith('audio/')) kind = 'audio';

                const maxMb = limits[kind] || limits.other;
                if (file.size > maxMb * 1024 * 1024) {
                    if (typeof this.$notify === 'function') {
                        this.$notify({
                            group: "error",
                            title: "File too large",
                            text: `"${file.name}" is too large. Max size for ${kind === 'other' ? 'documents' : kind + 's'} is ${maxMb}MB.`
                        }, 5000);
                    } else {
                        alert(`"${file.name}" is too large. Max size for ${kind === 'other' ? 'documents' : kind + 's'} is ${maxMb}MB.`);
                    }
                    continue;
                }
                validFiles.push(file);
            }

            if (validFiles.length === 0) return;

            const isFirstBatch = this.filesToUpload.length === 0;
            const fileObjs = validFiles.map((file, idx) => ({
                file: file,
                caption: (isFirstBatch && idx === 0) ? this.newMessage : ''
            }));

            if (isFirstBatch) {
                this.newMessage = ''; // Move main message to overlay caption
            }

            this.filesToUpload = [...this.filesToUpload, ...fileObjs];
            this.showPreviewOverlay = true;
            this.showPlusMenu = false;
            this.selectedFileIndex = isFirstBatch ? 0 : this.filesToUpload.length - validFiles.length;
        },
        getFileUrl(file) {
            if (!file) return '';
            // Handle both raw File and {file, caption} object
            const actualFile = file.file || file;
            return URL.createObjectURL(actualFile);
        },
        isImage(file) {
            const actualFile = file?.file || file;
            return actualFile && actualFile.type.startsWith('image/');
        },
        getFileExt(filename) {
            if (!filename) return '';
            return filename.split('.').pop();
        },
        formatFileSize(size) {
            if (!size) return '0 B';
            const i = Math.floor(Math.log(size) / Math.log(1024));
            return (size / Math.pow(1024, i)).toFixed(1) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
        },
        removeFile(index) {
            this.filesToUpload.splice(index, 1);
            if (this.filesToUpload.length === 0) {
                this.closePreviewOverlay(false);
            } else if (this.selectedFileIndex >= this.filesToUpload.length) {
                this.selectedFileIndex = this.filesToUpload.length - 1;
            }
        },
        closePreviewOverlay(isSent = false) {
            if (isSent !== true && this.filesToUpload.length > 0) {
                this.showDiscardModal = true;
                return;
            }
            this.executeClosePreviewOverlay();
        },
        confirmDiscardFiles() {
            // If the user typed a caption, sync it to the main chat input
            if (this.filesToUpload.length > 0) {
                const firstCaption = this.filesToUpload[0].caption;
                if (firstCaption) {
                    this.newMessage = firstCaption;
                }
            }
            this.showDiscardModal = false;
            this.executeClosePreviewOverlay();
        },
        executeClosePreviewOverlay() {
            this.showPreviewOverlay = false;
            this.filesToUpload = [];
            this.selectedFileIndex = 0;
            this.$nextTick(() => this.autoResize());
        },
        triggerFileInput() {
            this.$refs.docInput.click();
        },
        onSelectEmojiOverlay(emoji) {
            if (this.filesToUpload[this.selectedFileIndex]) {
                const input = this.$refs.captionInput;
                if (input) {
                    const start = input.selectionStart;
                    const end = input.selectionEnd;
                    const caption = this.filesToUpload[this.selectedFileIndex].caption || '';
                    this.filesToUpload[this.selectedFileIndex].caption = caption.substring(0, start) + emoji.i + caption.substring(end);
                    this.$nextTick(() => {
                        input.focus();
                        input.setSelectionRange(start + emoji.i.length, start + emoji.i.length);
                    });
                } else {
                    this.filesToUpload[this.selectedFileIndex].caption += emoji.i;
                }
            }
        },
        sendFiles() {
            this.sendMessage({ fromOverlay: true });
        },
        async sendMessage(opts = {}) {
            const fromOverlay = !!opts.fromOverlay;
            const inputEl = this.$refs.messageInput;

            // Get text from contenteditable if not from overlay
            let text = "";
            if (fromOverlay) {
                text = "";
            } else if (inputEl) {
                const content = inputEl.innerHTML;
                text = this.htmlToSymbols(content).trim();
            } else {
                text = (this.newMessage || "").trim();
            }

            const attachmentsToSend = fromOverlay ? this.filesToUpload : [];

            if (!text && (!attachmentsToSend || attachmentsToSend.length === 0)) return;
            if (!this.threadId) return;

            if (this.editingMessageId) {
                const base = this.chatBasePrefix();
                this.isSending = true;
                try {
                    // Update via PUT request since we only implemented an HTTP endpoint
                    const upRes = await window.axios.put(
                        `${base}/apartments/chat/threads/${this.thread.uuid}/messages/${this.editingMessageId}`,
                        { body: text }
                    );
                    if (upRes.data.ok) {
                        const updatedMsg = upRes.data.message;
                        // Trigger immediate local update
                        const idx = this.messages.findIndex(m => m.id === updatedMsg.id);
                        if (idx !== -1) {
                            // Using splice to ensure reactivity in older Vue setups just in case
                            this.messages.splice(idx, 1, updatedMsg);
                        }

                        if (this.socket) {
                            // Try multiple event names that common socket servers use
                            this.socket.emit("message.update", {
                                thread_id: this.threadId,
                                message_id: this.editingMessageId,
                                body: text
                            });
                            this.socket.emit("message.edit", {
                                thread_id: this.threadId,
                                message_id: this.editingMessageId,
                                body: text
                            });
                        }
                    }
                } catch (err) {
                    if (err.response && (err.response.status === 403 || err.response.status === 422)) {
                        this.$notify({
                            group: "error",
                            title: "Error",
                            text: err.response.data.message || err.response.data.error || "Cannot edit this message."
                        }, 4000);
                        // Refresh to hide stale edit buttons
                        this.loadMessages();
                    } else {
                        console.error(err);
                        this.$notify({
                            group: "error",
                            title: "Error",
                            text: "Failed to edit message."
                        }, 4000);
                    }
                } finally {
                    this.cancelEdit();
                    this.isSending = false;
                }
                return;
            }

            if (!this.socket) return;
            this.isSending = true;

            try {
                let attachments = [];

                if (attachmentsToSend && attachmentsToSend.length > 0) {
                    const base = this.chatBasePrefix();

                    const form = new FormData();
                    attachmentsToSend.forEach((f, idx) => {
                        form.append("files[]", f.file);
                        form.append(`captions[${idx}]`, f.caption || "");
                        // best-effort kind based on mime
                        const mime = (f.file?.type || "").toLowerCase();
                        const kind =
                            mime.startsWith("image/") ? "photo" :
                                mime.startsWith("video/") ? "video" :
                                    mime.startsWith("audio/") ? "audio" :
                                        (f.file?.name || "").toLowerCase().endsWith(".vcf") ? "contact" :
                                            "document";
                        form.append(`kinds[${idx}]`, kind);
                    });

                    const upRes = await window.axios.post(
                        `${base}/apartments/${this.apartment.uuid}/buyers/${this.selectedBuyer.id}/chat/upload`,
                        form,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );

                    attachments = upRes.data.uploads || [];
                }

                const commonPayload = this.getCommonSocketPayload();
                this.newMessage = "";
                if (this.$refs.messageInput) {
                    this.$refs.messageInput.innerHTML = "";
                }
                this.$nextTick(() => this.autoResize());
                this.clearReply();
                this.closePreviewOverlay(true);

                // 1. If we have a main body text, send it as a separate message
                if (text) {
                    this.socket.emit("message.send", {
                        ...commonPayload,
                        body: text,
                        attachments: [],
                    }, (ack) => {
                        if (ack?.ok) this.loadMessages();
                    });
                }

                // 2. Send each attachment as its own separate message
                for (const a of attachments) {
                    const payload = {
                        ...commonPayload,
                        body: a.caption || null,
                        attachments: [a],
                    };

                    this.socket.emit("message.send", payload, (ack) => {
                        if (ack?.ok) {
                            this.loadMessages();
                            this.$nextTick(() => this.scrollToBottom());
                        } else {
                            console.error("message.send failed for attachment", ack);
                        }
                    });
                }

                this.$nextTick(() => this.scrollToBottom());
            } catch (e) {
                console.error("Failed sending message", e);
                const msg = e.response?.data?.error || e.response?.data?.message || "Failed to send message. Please try again.";
                this.$notify({
                    group: "error",
                    title: "Error",
                    text: msg
                }, 4000);
            } finally {
                this.isSending = false;
            }
        },
        setReply(message) {
            this.replyingTo = message;
            this.activeMsgMenu = null;
            // Scroll to input to show the user the reply is active
            this.$nextTick(() => {
                const inputArea = this.$refs.messageInput;
                if (inputArea) inputArea.focus();
            });
        },
        startEdit(id) {
            const m = this.getMessageById(id);
            if (!m) return;

            const sentAtDate = new Date(m.sent_at);
            const diffInMinutes = (new Date() - sentAtDate) / (1000 * 60);

            const timeLimit = this.$page.props.chat_msg_edit_time_in_minute || 5;

            if (diffInMinutes > timeLimit) {
                this.$notify({
                    group: "error",
                    title: "Edit Limit Exceeded",
                    text: 'You can only edit messages within ' + timeLimit + ' minutes of sending.'
                }, 4000);
                this.activeMsgMenu = null;
                return;
            }

            this.editingMessageId = id;
            const bodyText = m.body || (m.attachments?.[0]?.original_name || "");
            this.newMessage = bodyText;

            this.activeMsgMenu = null;
            this.clearReply();

            this.$nextTick(() => {
                const inputArea = this.$refs.messageInput;
                if (inputArea) {
                    inputArea.innerHTML = this.symbolsToHtml(bodyText);
                    inputArea.focus();
                }
                this.autoResize();
            });
        },
        cancelEdit() {
            this.editingMessageId = null;
            this.newMessage = "";
            if (this.$refs.messageInput) {
                this.$refs.messageInput.innerHTML = "";
            }
            this.$nextTick(() => this.autoResize());
        },
        clearReply() {
            this.replyingTo = null;
        },
        getMessageById(id) {
            return (this.messages || []).find(m => m.id === id);
        },
        symbolsToHtml(text) {
            let html = text || "";
            // Escape HTML first
            const tmp = document.createElement('div');
            tmp.innerText = html;
            html = tmp.innerHTML;

            // Apply formatting
            html = html.replace(/\*(.*?)\*/g, '<b>$1</b>');
            html = html.replace(/__(.*?)__/g, '<u>$1</u>');
            html = html.replace(/_(.*?)_/g, '<i>$1</i>');
            html = html.replace(/~(.*?)~/g, '<del>$1</del>');
            html = html.replace(/`(.*?)`/g, '<code class="bg-gray-100 px-1 rounded font-mono text-pink-500">$1</code>');

            return html;
        },
        toggleMsgMenu(id) {
            this.activeMsgMenu = this.activeMsgMenu === id ? null : id;
        },
        copyMessage(text) {
            navigator.clipboard.writeText(text);
            this.activeMsgMenu = null;
            // You could add a toast here
        },
        reactToMessage(id, emoji) {
            if (!this.socket || !this.threadId) return;
            const m = this.getMessageById(id);
            const hasReacted = m && m.reactions && m.reactions.some(r => Number(r.user_id) === Number(this.$page.props.user.id) && r.emoji === emoji);

            this.socket.emit("message.react", {
                thread_id: this.threadId,
                message_id: id,
                emoji,
                op: hasReacted ? "remove" : "add",
            });
            this.activeMsgMenu = null;
        },
        toggleExpand(id) {
            this.expandedMessages[id] = !this.expandedMessages[id];
        },
        async openWebcam() {
            this.showPlusMenu = false;
            this.showWebcamModal = true;
            this.capturedImage = null;
            this.webcamError = null;

            try {
                this.webcamStream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: 'user' },
                    audio: false
                });
                this.$nextTick(() => {
                    const video = this.$refs.webcamVideo;
                    if (video) {
                        video.srcObject = this.webcamStream;
                    }
                });
            } catch (err) {
                console.error("Webcam access error:", err);
                this.webcamError = "Could not access camera. Please check permissions.";
            }
        },
        closeWebcam() {
            if (this.webcamStream) {
                this.webcamStream.getTracks().forEach(track => track.stop());
                this.webcamStream = null;
            }
            this.showWebcamModal = false;
            this.capturedImage = null;
        },
        takePhoto() {
            const video = this.$refs.webcamVideo;
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext('2d');

            // Mirror the capture to match the preview
            ctx.translate(canvas.width, 0);
            ctx.scale(-1, 1);

            ctx.drawImage(video, 0, 0);

            this.capturedImage = canvas.toDataURL('image/jpeg');

            // Stop stream after capture to save battery/resource
            if (this.webcamStream) {
                this.webcamStream.getTracks().forEach(track => track.stop());
                this.webcamStream = null;
            }
        },
        retakePhoto() {
            this.capturedImage = null;
            this.openWebcam();
        },
        confirmCapturedPhoto() {
            if (!this.capturedImage) return;

            // Convert dataURL to File object
            const arr = this.capturedImage.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            const file = new File([u8arr], `webcam_${Date.now()}.jpg`, { type: mime });

            // Pass to existing file handler
            this.handleFiles([file]);
            this.closeWebcam();
        },
        async downloadFile(obj) {
            // Handle both attachment objects and message objects
            let file = obj;
            if (obj && obj.attachments && obj.attachments.length > 0) {
                file = obj.attachments[0];
            }

            if (!file || !file.url) {
                console.error("Nothing to download", obj);
                return;
            }

            const fileName = file.original_name || file.fileName || 'download';

            try {
                const response = await fetch(file.url);
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (e) {
                console.error("Download failed, trying new tab fallback:", e);
                // Fallback: simple redirect with download hint
                const link = document.createElement('a');
                link.href = file.url;
                link.target = '_blank';
                link.download = fileName;
                link.click();
            }
            this.activeMsgMenu = null;
        },
        openLightbox(url, type = 'image', attachmentId = null) {
            this.lightboxUrl = url;
            this.lightboxType = type;

            if (attachmentId) {
                this.lightboxActiveIndex = this.lightboxItems.findIndex(i => i.id === attachmentId);
            } else {
                this.lightboxActiveIndex = this.lightboxItems.findIndex(i => i.url === url);
            }

            // Focus for keyboard support
            this.$nextTick(() => {
                const el = this.$refs.lightboxContainer;
                if (el) el.focus();
            });
        },
        nextLightboxItem() {
            if (this.lightboxActiveIndex < this.lightboxItems.length - 1) {
                this.lightboxActiveIndex++;
                const item = this.lightboxItems[this.lightboxActiveIndex];
                this.lightboxUrl = item.url;
                this.lightboxType = item.type;
            }
        },
        prevLightboxItem() {
            if (this.lightboxActiveIndex > 0) {
                this.lightboxActiveIndex--;
                const item = this.lightboxItems[this.lightboxActiveIndex];
                this.lightboxUrl = item.url;
                this.lightboxType = item.type;
            }
        },
        selectLightboxItem(index) {
            this.lightboxActiveIndex = index;
            const item = this.lightboxItems[index];
            this.lightboxUrl = item.url;
            this.lightboxType = item.type;
        },
        clearReply() {
            this.replyingTo = null;
        },
        formatMessageBody(text) {
            if (!text) return '';
            // Escape HTML for security
            let escaped = String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');

            // Convert newlines to <br> for multi-line support
            let formatted = escaped.replace(/\n/g, '<br>');

            // Bold: *text*
            formatted = formatted.replace(/\*([^\*]+?)\*/g, '<b>$1</b>');

            // Underline: __text__
            formatted = formatted.replace(/__([^_]+?)__/g, '<u>$1</u>');

            // Italic: _text_
            formatted = formatted.replace(/_([^_]+?)_/g, '<i>$1</i>');

            // Strikethrough: ~text~
            formatted = formatted.replace(/~([^~]+?)~/g, '<del>$1</del>');

            // Replace URLs with anchor tags
            const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
            return formatted.replace(urlRegex, function (url) {
                const href = url.startsWith('http') ? url : 'http://' + url;
                return `<a href="${href}" target="_blank" class="text-blue-500 hover:underline break-words">${url}</a>`;
            });
        },
        formatTime(dateStr) {
            if (!dateStr) return '';
            return moment(dateStr).format('HH:mm');
        },
        formatDateSimple(dateStr) {
            if (!dateStr) return '';
            try {
                const date = new Date(dateStr.replace(' ', 'T'));
                const now = new Date();

                // If today
                if (date.toDateString() === now.toDateString()) {
                    return moment(dateStr).format('HH:mm');
                }

                // If within last 7 days, show day name
                const diff = now - date;
                if (diff < 7 * 24 * 60 * 60 * 1000) {
                    return date.toLocaleDateString([], { weekday: 'long' });
                }

                // Otherwise show date
                return date.toLocaleDateString([], { month: 'numeric', day: 'numeric', year: 'numeric' });
            } catch (e) {
                return dateStr.split(' ')[0];
            }
        },
        formatDateLabel(dateStr) {
            if (!dateStr) return '';
            try {
                const date = new Date(dateStr.replace(' ', 'T'));
                const now = new Date();
                const yesterday = new Date();
                yesterday.setDate(now.getDate() - 1);

                if (date.toDateString() === now.toDateString()) {
                    return this.$t('chat.today') || 'Today';
                } else if (date.toDateString() === yesterday.toDateString()) {
                    return this.$t('chat.yesterday') || 'Yesterday';
                } else {
                    return date.toLocaleDateString([], { month: 'long', day: 'numeric', year: 'numeric' });
                }
            } catch (e) {
                return dateStr.split(' ')[0];
            }
        },
        async toggleChatDisabled() {
            if (!this.thread?.uuid) return;
            const base = this.chatBasePrefix();
            try {
                const res = await window.axios.post(`${base}/apartments/chat/threads/${this.thread.uuid}/toggle-disabled`);
                if (res.data.ok) {
                    this.thread.is_disabled = res.data.is_disabled;
                    this.$notify({
                        group: "success",
                        title: this.$t('chat.chatUpdated'),
                        text: this.thread.is_disabled ? this.$t('chat.chatDisabledMsg') : this.$t('chat.chatEnabledMsg')
                    }, 4000);

                    if (this.socket) {
                        this.socket.emit("thread.update", {
                            thread_id: this.threadId,
                            is_disabled: this.thread.is_disabled
                        });
                    }
                }
            } catch (err) {
                console.error(err);
                this.$notify({
                    group: "error",
                    title: "Error",
                    text: "Failed to update chat status."
                }, 4000);
            }
        },
        markThreadRead() {
            if (!this.socket || !this.threadId) return;
            const msgs = this.messages || [];
            const lastMsg = msgs.length ? msgs[msgs.length - 1] : null;
            this.socket.emit("thread.read", {
                thread_id: this.threadId,
                last_read_message_id: lastMsg ? lastMsg.id : null,
            });

            // Sync with backend for granular history. Guarded to avoid redundant
            // POSTs from reconnect storms / message bursts. The backend is now
            // idempotent, so this guard is purely an optimization.
            if (lastMsg) {
                this.syncReadStatus(lastMsg.id);
            }

            // Locally reset the count so the UI reflects it immediately
            const buyer = (this.chatBuyers || []).find(b => Number(b.id) === Number(this.selectedBuyer?.id));
            if (buyer) {
                buyer.unread_count = 0;
            }
        },
        syncReadStatus(messageId) {
            // Coalesce overlapping calls: if a request is already in flight, just
            // remember the newest id and fire one trailing sync when it completes.
            if (this._readSyncInFlight) {
                this._pendingReadId = Math.max(this._pendingReadId || 0, messageId);
                return;
            }
            // Skip if we've already synced this message (or a newer one).
            if ((this._lastSyncedReadId || 0) >= messageId) return;

            this._readSyncInFlight = true;
            const base = this.chatBasePrefix();
            window.axios.post(`${base}/apartments/chat/threads/${this.thread.uuid}/read`, {
                message_id: messageId
            }).then(() => {
                this._lastSyncedReadId = messageId;
            }).catch(e => console.error("Failed to sync read status", e))
                .finally(() => {
                    this._readSyncInFlight = false;
                    // A newer message may have arrived while we were syncing.
                    const pending = this._pendingReadId || 0;
                    this._pendingReadId = 0;
                    if (pending > (this._lastSyncedReadId || 0)) {
                        this.syncReadStatus(pending);
                    }
                });
        },
        handleMediaPlay(event) {
            // Stop all other audio/video tags from playing simultaneously
            const allMedia = document.querySelectorAll('audio, video');
            allMedia.forEach(m => {
                if (m !== event.target && !m.paused) {
                    m.pause();
                }
            });

            // Sync UI states for custom players if applicable
            Object.keys(this.activeAudioIds).forEach(id => {
                if (id !== event.target.id) {
                    this.activeAudioIds[id] = false;
                }
            });
        },
        toggleAudioPlayback(elId) {
            const el = document.getElementById(elId);
            if (!el) return;
            if (el.paused) {
                el.play();
                this.activeAudioIds[elId] = true;
            } else {
                el.pause();
                this.activeAudioIds[elId] = false;
            }
        },
        onAudioMetadata(elId, event) {
            this.audioDurationMap[elId] = event.target.duration;
        },
        onAudioTimeUpdate(elId, event) {
            const el = event.target;
            this.audioCurrentTimeMap[elId] = el.currentTime;
            this.audioProgressMap[elId] = (el.currentTime / el.duration) * 100;
        },
        onAudioEnded(elId) {
            this.activeAudioIds[elId] = false;
            this.audioCurrentTimeMap[elId] = 0;
            this.audioProgressMap[elId] = 0;
        },
        checkSelection() {
            const selection = window.getSelection();
            this.showFormattingToolbar = selection && selection.toString().length > 0;
        },
        handleInput(e) {
            const el = this.$refs.messageInput;
            if (!el) return;

            // If empty, ensure no hidden HTML remains
            if (!el.innerText.trim()) {
                el.innerHTML = "";
            }

            this.newMessage = el.innerText;
            this.autoResize();
            this.showFormattingToolbar = false;
        },
        handleKeyDown(e) {
            // If space is pressed, check if we should "break out" of a formatting tag
            if (e.key === ' ') {
                const selection = window.getSelection();
                if (selection.rangeCount > 0) {
                    const range = selection.getRangeAt(0);
                    const node = range.startContainer;

                    // If we are at the end of a text node inside a formatting tag
                    if (node.nodeType === 3 && range.startOffset === node.length) {
                        const parent = node.parentNode;
                        const tags = ['B', 'I', 'U', 'S', 'STRIKE', 'EM', 'STRONG', 'CODE'];
                        if (tags.includes(parent.tagName)) {
                            // Break out of the tag by inserting space after it
                            e.preventDefault();
                            const space = document.createTextNode('\u00A0'); // Non-breaking space
                            parent.parentNode.insertBefore(space, parent.nextSibling);

                            // Move cursor after the space
                            const newRange = document.createRange();
                            newRange.setStartAfter(space);
                            newRange.collapse(true);
                            selection.removeAllRanges();
                            selection.addRange(newRange);

                            this.handleInput();
                        }
                    }
                }
            }
        },
        applyFormatting(symbol) {
            const input = this.$refs.messageInput;
            if (!input) return;

            // Focus first to ensure execCommand works on the right element
            input.focus();

            let command = '';
            if (symbol === '*') command = 'bold';
            else if (symbol === '_') command = 'italic';
            else if (symbol === '__') command = 'underline';
            else if (symbol === '~') command = 'strikeThrough';

            if (command) {
                document.execCommand(command, false, null);
            } else {
                // Fallback for symbols like Code or Quote that don't have execCommands
                const selection = window.getSelection();
                if (!selection.rangeCount) return;
                const range = selection.getRangeAt(0);
                const selectedText = range.toString();

                if (symbol === '`') {
                    const code = document.createElement('code');
                    code.className = 'bg-gray-100 px-1 rounded font-mono text-pink-500';
                    code.innerText = selectedText;
                    range.deleteContents();
                    range.insertNode(code);
                }
            }

            this.showFormattingToolbar = false;
            this.handleInput(); // Sync back to newMessage
        },
        htmlToSymbols(html) {
            let text = html;

            // Convert span styles to tags first for easier processing
            text = text.replace(/<span style="font-weight:\s*bold;?">(.*?)<\/span>/gi, '<b>$1</b>');
            text = text.replace(/<span style="font-style:\s*italic;?">(.*?)<\/span>/gi, '<i>$1</i>');
            text = text.replace(/<span style="text-decoration:\s*underline;?">(.*?)<\/span>/gi, '<u>$1</u>');
            text = text.replace(/<span style="text-decoration:\s*line-through;?">(.*?)<\/span>/gi, '<del>$1</del>');

            // Replace common tags with symbols
            text = text.replace(/<b>(.*?)<\/b>/gi, '*$1*');
            text = text.replace(/<strong>(.*?)<\/strong>/gi, '*$1*');
            text = text.replace(/<u>(.*?)<\/u>/gi, '__$1__');
            text = text.replace(/<i>(.*?)<\/i>/gi, '_$1_');
            text = text.replace(/<em>(.*?)<\/em>/gi, '_$1_');
            text = text.replace(/<del>(.*?)<\/del>/gi, '~$1~');
            text = text.replace(/<strike>(.*?)<\/strike>/gi, '~$1~');
            text = text.replace(/<code>(.*?)<\/code>/gi, '`$1`');

            // Replace <br> and <div> with newlines
            text = text.replace(/<br\s*\/?>/gi, '\n');
            text = text.replace(/<\/div>/gi, '\n');
            text = text.replace(/<div>/gi, '');

            // Strip remaining HTML
            const tmp = document.createElement('div');
            tmp.innerHTML = text;
            return tmp.innerText || tmp.textContent || text;
        },
        seekAudioGlobal(elId, event) {
            const el = document.getElementById(elId);
            if (!el || !el.duration) return;
            const rect = event.currentTarget.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const percent = x / rect.width;
            el.currentTime = percent * el.duration;
        },
        handleScroll(event) {
            const el = event.target;
            // If near top (less than 100px from top)
            if (el.scrollTop < 100) {
                this.loadMoreMessages();
            }

            // If near bottom (less than 100px from bottom) and we have future messages
            if (this.hasMoreFutureMessages && (el.scrollHeight - el.scrollTop - el.clientHeight < 100)) {
                this.loadMoreFutureMessages();
            }

            // Show scroll to bottom button if more than 300px from bottom
            const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
            this.showScrollToBottom = distanceToBottom > 300;
        },
        formatAttachmentType(type) {
            if (!type) return 'Attachment';
            if (type === 'photo' || type === 'image') return 'Photo';
            if (type === 'video') return 'Video';
            if (type === 'audio') return 'Audio';
            return 'Document';
        },
        showReactionSummary(message) {
            this.activeReactionMessage = message;
            this.showReactionModal = true;
        },
        closeReactionModal() {
            this.showReactionModal = false;
            this.activeReactionMessage = null;
        },
        async showMessageInfo(messageId) {
            this.showMsgInfoModal = true;
            this.msgInfo.isLoading = true;
            this.msgInfo.message = this.messages.find(m => m.id === messageId);

            try {
                const routeName = this.is_advisor ? 'advisors.chat.threads.messages.seen' : 'clients.chat.threads.messages.seen';
                const response = await axios.get(route(routeName, {
                    thread: this.thread.uuid,
                    message: messageId
                }));
                if (response.data.ok) {
                    this.msgInfo.seen_by = response.data.seen_by;
                }
            } catch (error) {
                console.error("Failed to fetch message info:", error);
            } finally {
                this.msgInfo.isLoading = false;
            }
        },
        closeMsgInfoModal() {
            this.showMsgInfoModal = false;
            this.msgInfo.message = null;
            this.msgInfo.seen_by = [];
        },
        openDocumentPreview(attachment) {
            this.previewFile = { url: attachment.url, name: attachment.original_name };
        },
        advisorColor(userId) {
            const palette = ['#7c3aed', '#dc2626', '#059669', '#d97706', '#0284c7', '#db2777'];
            return palette[Number(userId) % palette.length];
        },
        openAdvisorPopup(event, message) {
            const viewerType = this.$page.props.user.type;
            const senderKind = message.sender_kind;
            // Buyer clicks on advisor message, or advisor clicks on buyer message
            const canOpen = (viewerType === 'buyer' && senderKind === 'advisor');
            if (!canOpen) return;
            const rect = event.currentTarget.getBoundingClientRect();
            const POPUP_H = 165;
            const POPUP_W = 264;
            const top  = Math.min(rect.bottom + 8, window.innerHeight - POPUP_H - 8);
            const left = Math.min(rect.left, window.innerWidth - POPUP_W - 8);
            this.activeAdvisorPopup = {
                senderName:   message.sender_name,
                senderAvatar: message.sender_avatar,
                senderEmail:  message.sender_email,
                senderMobile: message.sender_mobile,
                senderKind,
                top,
                left,
            };
        },
    }
};
